// extracted by mini-css-extract-plugin
export default {"note":"procedure_note__2P2BJ","icon":"procedure_icon__EqL-j","content":"procedure_content__z6lWw"};